<template>
  <g fill="inherit">
    <rect height="2" width="14" x="2" y="8" fill="inherit"></rect>
  </g>
</template>

<script>
export default {
  name: 'icon-minus',
}
</script>
